import CommunityModeration from "@/features/community/moderation";

const CommunityModerationPage = () => <CommunityModeration />;

export default CommunityModerationPage;
